<template >
  <div class=" flex-row align-items-center" v-bind:style="{'margin-top': '10%'}">
    <div class=" text-center">
      <h3 v-bind:style="{color: 'blue'}">Nusanet Information Systems</h3>
      <!--<small>You have been logged out</small>-->
      <small v-if="empty">Please Insert Username or Password</small>
      <div v-bind:style="{background: '#EAEAE1',}" align="center">
        <table >
          <tr>
            <td>
              <strong>Employee ID</strong>
            </td>
            <td>
              <strong>
                Password
              </strong>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <b-form-input type="text"
                            class="form-control"
                            placeholder="Username"
                            autocomplete="username email"
                            v-model="id"
                            @keyup.native="keydown"/>
            </td>
            <td>
              <b-form-input type="password"
                            class="form-control"
                            placeholder="Password"
                            autocomplete="current-password"
                            v-model="password"
                            @keyup.native="keydown"/>
            </td>
            <td>
              <b-button variant="primary" class="px-4" @click="routes">Login</b-button>
            </td>
          </tr>
          <tr>
            <td colspan="2" align="center">
              <small>
                <a href="#" >Forgot your password</a>
              </small>
            </td>
            <td></td>
          </tr>
        </table>
      </div>
      Copyright © 2004-2019 PT Media Antar Nusa. All Rights Reserved.
    </div>
  </div>
</template>>

<script>
  import {getService} from "../../services";

  export default {
  name: 'Login',
  data() {
    return {
      id: '',
      password : '',
      empty: false
    }
  },
  methods: {
    routes: function(event) {
      // this.$router.push({path: '/general/dashboard'});
      if(this.id != '' && this.password != '') {
        this.$store.dispatch("login", {
          id: this.id,
          password: this.password
        });
      } else {
        this.empty = true
      }
    },
    keydown: function (event) {
     if (this.id == '' || this.password == '') {
       this.empty = false
     }
    },
    checkStatus() {
        if (localStorage.token) {
            getService.profile()
                .then(data => {
                   this.$router.push({path: '/dashboard'})
                })
        } else {
            getService.getTokenFromIS()
        }
    }
  },
  created() {
    var that = this
    this.checkStatus()
    window.addEventListener('keydown', (e) => {
      if (e.key == 'Enter') {
         that.routes()
      }
    });
  }
}
</script>
